enum EventNames {
  SHOW_SNACKBAR = 'showSnackbar',
  DF_UPDATE_NODE_DETAILS = 'UpdateNodeDetails'
}

export default EventNames
